export const OrganizationParametersGeneration = organizationData => {
  const options = new URLSearchParams()
  options.append('name', organizationData.name)
  options.append('zoho_prefix', organizationData.zoho_prefix)
  options.append('telecom_zoho_mobile_options_name', organizationData.telecom_zoho_mobile_options_name ?? '')
  options.append('telecom_zoho_box_options_name', organizationData.telecom_zoho_box_options_name ?? '')

  return options
}
